import { ShieldHomeOutlineIcon } from './ShieldHomeOutlineIcon';

/**
 * author: Michael Irigoyen
 * id 4D4B922B-D9AA-47AC-8E02-33F88EC69B38
 * name shield-home-outline
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/shield-home-outline.svg
 * tags
 * - Home Automation 
 */
export const ShieldHouseOutlineIcon = ShieldHomeOutlineIcon;
export default ShieldHouseOutlineIcon